import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeForMultipleBounds,
  alternativeOfferConfirmationJobMock,
  alternativeOfferInProgressJobMock,
  alternativeOffersCphOsl,
  alternativeOffersOslCph,
  asyncAlternativeOfferConfirmationJobCompletedFor0E,
  asyncAlternativeOfferConfirmationJobInProgressFor0E,
  orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip,
  orderEligibilitiesMockNotEligibleToRefundForSingleBound,
  orderForSingleBoundAcknowledged,
  orderWithBothBoundsAcknowledged,
  orderWithOneBoundSisterCity,
  orderWithReturnBoundDisrupted,
  orderWithRoundTripSisterCity,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderEligibilitiesForSisterCityTwoBounds,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const singleBoundDisruptedSisterCityMock: MockMap = {
  retrieveOrder: [createMockData(orderWithOneBoundSisterCity, [], [flightDisruptionWarning]),
    createMockData(orderForSingleBoundAcknowledged)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl)],
  acknowledge: [createMockData({})],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [createMockData(alternativeOfferConfirmationJobMock)]
};

export const multiDisruptedBoundsSisterCityAcknowledgeOneByOneMock: MockMap = {
  retrieveOrder: [createMockData(orderWithRoundTripSisterCity, [], [flightDisruptionWarning]),
    createMockData({
      ...orderWithReturnBoundDisrupted,
      orderEligibilities: orderEligibilitiesForSisterCityTwoBounds
    }),
    createMockData(orderWithBothBoundsAcknowledged)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleToRefundForSingleBound, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl), createMockData(alternativeOffersOslCph)],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(asyncAlternativeOfferConfirmationJobInProgressFor0E)],
  getAlternativeOfferConfirmationJob: [createMockData(asyncAlternativeOfferConfirmationJobCompletedFor0E)],
  acknowledge: [createMockData(acknowledgeForMultipleBounds)]
};

export const multiDisruptedBoundsRebookTogetherSisterCityMock: MockMap = {
  retrieveOrder: [
    createMockData(orderWithRoundTripSisterCity, [], [flightDisruptionWarning]),
    createMockData(orderWithBothBoundsAcknowledged)
  ],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockNotEligibleFororderForSinglePaxRoundTrip)],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl), createMockData(alternativeOffersOslCph)],
  acknowledge: [createMockData({})],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(asyncAlternativeOfferConfirmationJobInProgressFor0E)],
  getAlternativeOfferConfirmationJob: [createMockData(asyncAlternativeOfferConfirmationJobCompletedFor0E)]
};
